import { navigate } from "@reach/router"

export const navigationWithAltClick = (
  path: string,
  e?: React.MouseEvent<HTMLElement>,
  baseUrl?: string,
  baseUrlForNewTabOnly?: boolean
) => {
  if (e) {
    e.preventDefault()
    if (e.altKey) {
      const newPath = path.replace(/^\//, ``)
      window.open(`${baseUrl || window.location.origin}/${newPath}`, `_blank`, `noopener noreferrer`)
      return
    }
  }
  navigate(baseUrl && !baseUrlForNewTabOnly ? `${baseUrl}/${path.replace(/^\//, ``)}` : path)
}
